<template>
  <div class="w-full h-full flex justify-center items-center pending">
    <div
      class="uppercase flex h-9 w-full items-center justify-center rounded-lg border-2 border-input bg-background px-3 pt-1 text-2xl font-bold"
      :class="{
        '!border-[#298759] text-[#298759]': value == 'paid',
        '!border-[#B8951C] text-[#B8951C]': value == 'partialPay',
        '!border-[#D10D25] text-[#D10D25]': value == 'notPaid',
        '!bg-[#FFFFFF] border-red-500 text-red-500': value == 'returned',
      }">
      {{ label }}
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useContext } from "@/plugins/context";
import { i18nOrderMessages, Order } from "@/models/sales/Order";
import { useI18n } from "vue-i18n";
import { useSettingsStore } from '@/stores/settingsStore';

export default defineComponent({
  setup() {
    const ctx = useContext();
    const settingsStore = useSettingsStore();

    const order = ref<Order | null>(null);
    const value = ref<string>("")
    const label = ref<string>("")

    return {
      ctx,
      order,
      value,
      label,
      settingsStore
    }
  },
  props: ['data'],
  mounted() {
    /* @ts-ignore */
    this.order = (this.params?.data || this.$props.data) as Order;
    if (!this.order) {
      return;
    }

    if (this.order.orderItems.filter((oi) => oi.quantity == oi.returnedQuantity).length > 0) {
      this.value = 'returned'
      this.label = this.settingsStore.getValue('receipt_language') == 'en' ? 'Returned': 'مسترجعة'
      return;
    }

    if (this.order.invoice.totalPaidAmount > 0 && this.order.invoice.totalDueAmount != this.order.invoice.totalPaidAmount) {
      this.value = 'partialPay'
      this.label = this.settingsStore.getValue('receipt_language') == 'en' ? 'Partial Pay': 'دفع جزئي'
      return;
    }

    if (this.order.invoice.totalPaidAmount == this.order.invoice.totalDueAmount) {
      this.value = 'paid'
      this.label = this.settingsStore.getValue('receipt_language') == 'en' ? 'Paid': 'مدفوعة'
      return;
    }

    if (this.order.invoice.totalPaidAmount == 0) {
      this.value = 'notPaid'
      this.label = this.settingsStore.getValue('receipt_language') == 'en' ? 'Not Paid': 'غير مدفوعة'
      return;
    }
  }
})
</script>
